module.exports = __webpack_public_path__ + "img/location_pin.57dffb95.png";